/* eslint-disable max-len */
import React from 'react';
import Emptyscreenwithouttitle from '../../../components/Emptyscreenwithouttitle';

export default function OrganizationAssociatedTouser({data}) {

    return (
        <>  
            {<>
                <div className='border border-[#EDD7E1] mt-6 rounded pb-2'>
                    <div className='relative flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px]'>
                        <p className='text-base font-semibold text-[#972E4C]'>Organization List</p>
                    </div>
                    <table aria-label="Outside Table" className="w-full table-fixed">
                        <thead>
                            <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-[1]">
                                <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        ID
                                    </span>
                                </th>
                                <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        Organization Name
                                    </span>
                                </th>
                                <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        Sub Division Name
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.subdivisionDetails && data?.subdivisionDetails?.length>0 && data?.subdivisionDetails?.map((organizationList, index) => (
                
                                <tr key={index}>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {organizationList.organization_id}
                
                                    </td>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {organizationList.organization_name}
                                    </td>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {organizationList.subdivision_name}
                                    </td>
                                </tr>

                            ))}
                
                        </tbody>
                    </table>
                </div>
            </>}
        </>
    )
}
